<template>
    <div>
        <p>Adicionar variações de botões aqui</p>
    </div>
</template>

<script>
export default {

}
</script>